// File: frontend/src/components/utility/ErrorBoundary.js

import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import styles from './ErrorBoundary.module.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Log error to monitoring service
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback error={this.state.error} />;
    }

    return this.props.children;
  }
}

const ErrorFallback = ({ error }) => {
  const { t } = useLanguage();
  
  return (
    <div className={styles.errorBoundary}>
      <div className={styles.errorContent}>
        <h2 className={styles.errorTitle}>
          {t('error_boundary_title', 'Something went wrong')}
        </h2>
        <p className={styles.errorDescription}>
          {t('error_boundary_description', 'We apologize for the inconvenience. Please refresh the page or try again later.')}
        </p>
        <button 
          className={styles.errorButton}
          onClick={() => window.location.reload()}
        >
          {t('button_refresh', 'Refresh Page')}
        </button>
        
        {process.env.REACT_APP_APP_ENV === 'dev' && error && (
          <details className={styles.errorDetails}>
            <summary>Error Details (Development)</summary>
            <pre className={styles.errorStack}>
              {error.toString()}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
};

export default ErrorBoundary;
